import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Cabbookingfrommumbaitopune() {



  const cardData =
  {
    keyword: 'Cab Booking from Mumbai to Pune',
    heading: 'Aaryan Travels: Cab Booking from Mumbai to Pune',
    headingDescription: ' Aaryan Travels offers hassle-free Cab Booking from Mumbai to Pune, ensuring a smooth and comfortable journey across the busy Mumbai-Pune Expressway. Whether you are traveling for business, family visits, airport pickup, or weekend getaway, our fleet of sedans, SUVs, and premium cabs guarantees a safe and enjoyable ride. With experienced chauffeurs, on-time pickups from any location in Mumbai—including Airport, Dadar, Thane, Navi Mumbai, and Borivali—we provide doorstep pickup and drop at your convenience. Enjoy transparent fares, zero hidden charges, and 24/7 availability when you book your Mumbai to Pune cab with Aaryan Travels for a seamless intercity travel experience.',

    top: 'Top Places to Visit in Pune with Aaryan Travels',

  "topPlaces": [
  {
    "title": "Shaniwar Wada",
    "description": "Built in 1732 by the Peshwas, Shaniwar Wada is Pune’s most iconic fort palace. It was once the seat of the Maratha Empire and still echoes the legacy of Bajirao and Mastani. Its mighty Delhi Gate, fountains, and expansive gardens attract thousands of visitors. Though destroyed by fire in 1828, the ruins still retain grandeur. The evening light-and-sound show recreates Maratha history. Shaniwar Wada is Pune’s proud heritage landmark."
  },
  {
    "title": "Aga Khan Palace",
    "description": "Aga Khan Palace, constructed in 1892, is a majestic monument tied to India’s freedom struggle. Mahatma Gandhi, Kasturba Gandhi, and Mahadev Desai were imprisoned here during the Quit India Movement. Today, it serves as a museum displaying Gandhi’s personal belongings and photographs. Its sprawling lawns and Italian arches add to the charm. It is also the resting place of Kasturba Gandhi. Aga Khan Palace is Pune’s historical gem of inspiration."
  },
  {
    "title": "Sinhagad Fort",
    "description": "Sinhagad Fort, located 25 km from Pune, is renowned for the 1670 battle where Tanaji Malusare sacrificed his life for Chhatrapati Shivaji Maharaj. The fort sits atop a hill offering trekking trails and panoramic Sahyadri views. Visitors explore its bastions, memorials, and temples reflecting Maratha valor. Monsoon adds mist, waterfalls, and greenery. Local villagers serve rustic pithla-bhakri meals. Sinhagad is Pune’s perfect mix of history, trekking, and nature."
  },
  {
    "title": "Dagdusheth Halwai Ganpati Temple",
    "description": "The Shreemant Dagdusheth Halwai Ganpati Temple is Pune’s most revered shrine dedicated to Lord Ganesha. The idol, adorned with gold and ornaments, attracts lakhs of devotees annually. During Ganesh Chaturthi, the temple becomes the epicenter of grand festivities. It is also known for charitable and cultural activities. The spiritual aura here draws devotees and tourists alike. Dagdusheth Ganpati is Pune’s divine cultural heart."
  },
  {
    "title": "Pataleshwar Cave Temple",
    "description": "Pataleshwar Cave Temple, carved in the 8th century, is a rock-cut shrine dedicated to Lord Shiva. The site features a sanctum, massive stone pillars, and a Nandi mandapa. Despite being in the city’s center, it offers peace and a spiritual retreat. Evening chants enhance the mystical ambiance. Its carvings showcase early Indian rock-cut craftsmanship. Pataleshwar is Pune’s hidden heritage gem."
  },
  {
    "title": "Raja Dinkar Kelkar Museum",
    "description": "Raja Dinkar Kelkar Museum is a treasure trove with over 20,000 artifacts collected by Dr. Dinkar Kelkar. The collection includes ornaments, sculptures, musical instruments, and antiques of daily life. The recreated Mastani Mahal is the highlight for visitors. Students and history enthusiasts find it fascinating and educational. It preserves centuries of cultural heritage. The museum is Pune’s proud showcase of art and tradition."
  },
  {
    "title": "Parvati Hill and Temple",
    "description": "Parvati Hill, one of Pune’s oldest landmarks, offers panoramic views of the city. The hilltop houses the Parvati Temple dedicated to Lord Shiva and Goddess Parvati, built during the Peshwa era. Visitors climb 103 steps to reach the shrine, blending devotion with adventure. Smaller shrines and a museum add cultural depth. Sunrises and sunsets from here are breathtaking. Parvati Hill is Pune’s sacred and scenic retreat."
  },
  {
    "title": "Osho Ashram",
    "description": "The Osho International Meditation Resort in Koregaon Park is Pune’s global hub of wellness and spirituality. Spread across serene gardens, it offers meditation, yoga, and personal growth workshops. Zen-inspired landscapes and modern facilities attract seekers worldwide. Visitors experience rejuvenation, peace, and mindfulness here. It is a unique blend of spirituality and modern lifestyle. Osho Ashram is Pune’s international retreat of tranquility."
  },
  {
    "title": "Pu La Deshpande Garden",
    "description": "Pu La Deshpande Garden, modeled after Japan’s Korakuen Garden, is Pune’s largest landscaped park. It features flowing streams, stone bridges, and manicured lawns. Families and couples enjoy peaceful walks, picnics, and photography here. Seasonal flowers add charm throughout the year. The garden reflects Indo-Japanese cultural ties. Pu La Deshpande Garden is Pune’s lush green paradise."
  },
  {
    "title": "Khadakwasla Dam",
    "description": "Khadakwasla Dam, built on the Mutha River, is a popular weekend getaway near Pune. It supplies water to the city while offering scenic landscapes. Monsoon turns it into a picturesque spot with overflowing waters. Vendors selling hot corn and tea add to the charm. It also serves as the gateway to Sinhagad Fort. Khadakwasla is Pune’s refreshing natural retreat."
  }
],


  "services": [
  {
    "name": "Cab Booking from Mumbai to Pune",
    "description": "Easily book your cab from Mumbai to Pune with our seamless online and offline booking options. Enjoy flexible scheduling, instant confirmations, and a wide range of vehicles tailored to your preferences. Whether traveling for business, leisure, or urgent needs, our service guarantees reliable pickups, professional drivers, and comfortable rides for a smooth intercity journey."
  },
  {
    "name": "Mumbai to Pune Taxi",
    "description": "Travel comfortably between Mumbai and Pune with our dedicated Mumbai to Pune Taxi service. Offering well-maintained vehicles and experienced drivers, this service ensures timely pickups and drop-offs along the route. Perfect for daily commuters, tourists, and corporate travelers looking for a hassle-free and efficient ride between the two cities."
  },
  {
    "name": "Intercity Cab Mumbai Pune",
    "description": "Our Intercity Cab service between Mumbai and Pune offers flexible travel options including one-way trips, round trips, and multi-day rentals. Choose from sedans, SUVs, and luxury vehicles to match your travel requirements. Professional drivers with deep knowledge of the highway and traffic patterns ensure a safe and pleasant journey."
  },
  {
    "name": "One Way Cab Mumbai to Pune",
    "description": "Book a convenient One Way Cab from Mumbai to Pune for quick, efficient transfers without the hassle of return trips. Ideal for business meetings, airport drop-offs, or personal travel, this service provides competitive pricing, prompt pickups, and comfortable vehicles to make your journey stress-free and timely."
  },
  {
    "name": "Outstation Taxi Mumbai Pune",
    "description": "Our Outstation Taxi service between Mumbai and Pune caters to travelers looking for reliable, comfortable transportation beyond city limits. With options for both short and long-duration trips, the service features skilled drivers, clean vehicles, and transparent pricing to ensure a pleasant travel experience on this popular intercity route."
  },
  {
    "name": "Affordable Mumbai Pune Cab",
    "description": "Choose Affordable Mumbai Pune Cab options that balance cost and comfort perfectly. Designed for budget-conscious travelers, this service offers clean, reliable vehicles and professional drivers at competitive rates. Whether commuting for work or visiting family, enjoy safe and economical transportation between the two cities."
  },
  {
    "name": "Mumbai to Pune Chauffeur Cab",
    "description": "Experience premium service with Mumbai to Pune Chauffeur Cabs, featuring professional, courteous drivers who prioritize your comfort and safety. Ideal for corporate travelers and executives, this service provides luxury vehicles, flexible scheduling, and a stress-free travel experience between Mumbai and Pune."
  },
  {
    "name": "Online Cab Booking Mumbai Pune",
    "description": "Book your Mumbai to Pune cab online with our user-friendly platforms offering instant confirmations, fare estimates, and multiple payment options. Schedule rides in advance or book on demand, ensuring you never miss important appointments or connections. Enjoy transparent pricing and real-time tracking for peace of mind throughout your journey."
  },
  {
    "name": "Mumbai to Pune Sedan Cab",
    "description": "Travel in style and comfort with our Mumbai to Pune Sedan Cab service, featuring well-maintained sedans ideal for solo travelers, couples, or small groups. Sedans provide a perfect balance of affordability and comfort, with professional drivers ensuring a smooth and punctual ride along this busy intercity corridor."
  },
  {
    "name": "Mumbai to Pune SUV Hire",
    "description": "For larger groups or those seeking extra space, our Mumbai to Pune SUV Hire service offers spacious, comfortable vehicles with powerful performance. Ideal for family trips, corporate travel, or those carrying extra luggage, these SUVs come with experienced drivers who navigate the Mumbai-Pune highway safely and efficiently."
  },
  {
    "name": "Best Cab Service Mumbai Pune",
    "description": "Rely on the Best Cab Service between Mumbai and Pune, known for exceptional customer support, punctuality, and vehicle quality. This service caters to all types of travelers, providing flexible options, transparent fares, and a smooth booking experience for hassle-free intercity travel."
  },
  {
    "name": "Express Cab Mumbai to Pune",
    "description": "Need to reach Pune quickly? Our Express Cab service offers fast, direct rides between Mumbai and Pune with minimal stops. Benefit from professional drivers adept at choosing the best routes to avoid traffic delays, ensuring you arrive on time for important meetings, flights, or events."
  },
  {
    "name": "Taxi Near Me for Mumbai to Pune",
    "description": "Find the nearest available taxi for your Mumbai to Pune trip with our GPS-enabled dispatch system. This service reduces wait times by connecting you to nearby drivers ready to start your journey promptly. Enjoy transparent pricing, verified vehicles, and reliable rides whenever you need to travel between these cities."
  },
  {
    "name": "Mumbai Pune Highway Cab",
    "description": "Travel confidently along the Mumbai Pune highway with our specialized highway cab service. Drivers are trained to navigate traffic and road conditions efficiently, ensuring a safe and comfortable journey. Our fleet includes vehicles equipped with safety features and amenities suitable for long-distance highway travel."
  },
  {
    "name": "Premium Cab Mumbai to Pune",
    "description": "Indulge in luxury with Premium Cab services from Mumbai to Pune, offering high-end sedans and SUVs with professional chauffeurs. Perfect for executives, VIPs, and special occasions, this service provides superior comfort, privacy, and amenities like Wi-Fi and refreshments for an exclusive travel experience."
  }
],
"tableData": [
  ["Cab Booking from Mumbai to Pune", "Mumbai to Pune Taxi"],
  ["Intercity Cab Mumbai Pune", "One Way Cab Mumbai to Pune"],
  ["Outstation Taxi Mumbai Pune", "Affordable Mumbai Pune Cab"],
  ["Mumbai to Pune Chauffeur Cab", "Online Cab Booking Mumbai Pune"],
  ["Mumbai to Pune Sedan Cab", "Mumbai to Pune SUV Hire"],
  ["Best Cab Service Mumbai Pune", "Express Cab Mumbai to Pune"],
  ["Taxi Near Me for Mumbai to Pune", "Mumbai Pune Highway Cab"],
  ["Premium Cab Mumbai to Pune", "—"]
],


"whychoose": [
  {
    "WhyChooseheading": "Reliable Cab Booking from Mumbai to Pune",
    "WhyChoosedescription": "Aaryan Travels offers seamless cab services for your Mumbai to Pune journey with punctual pickups and comfortable rides."
  },
  {
    "WhyChooseheading": "Timely Pickup from Any Location in Mumbai",
    "WhyChoosedescription": "Our drivers are ready across Mumbai to ensure timely and convenient pickups to start your Pune trip without delays."
  },
  {
    "WhyChooseheading": "Comfortable and Well-Maintained Vehicles",
    "WhyChoosedescription": "Travel in sanitized, air-conditioned vehicles designed for your comfort on the Mumbai-Pune route."
  },
  {
    "WhyChooseheading": "Experienced Drivers Familiar with Mumbai-Pune Expressway",
    "WhyChoosedescription": "Our professional drivers know the fastest and safest routes between Mumbai and Pune for a smooth journey."
  },
  {
    "WhyChooseheading": "Transparent Pricing with No Hidden Charges",
    "WhyChoosedescription": "Get upfront pricing including tolls, fuel, and driver allowances for your Mumbai to Pune trip."
  },
  {
    "WhyChooseheading": "24/7 Customer Support for Booking Assistance",
    "WhyChoosedescription": "Our team is available round the clock to help you book your Mumbai to Pune cab hassle-free."
  },
  {
    "WhyChooseheading": "Flexible Options for One-Way and Round Trips",
    "WhyChoosedescription": "Choose from one-way rides or round trips as per your travel needs between Mumbai and Pune."
  },
  {
    "WhyChooseheading": "Wide Range of Vehicles to Suit Your Group Size",
    "WhyChoosedescription": "Select from hatchbacks, sedans, SUVs, or tempo travellers depending on your comfort and luggage requirements."
  }
]


























  }

const faqData = [
  {
    question: 'Does Aaryan Travels offer cab booking services from Mumbai to Pune?',
    answer: 'Yes, Aaryan Travels provides reliable and comfortable cab services for travel from Mumbai to Pune.',
  },
  {
    question: 'How can I book a cab from Mumbai to Pune with Aaryan Travels?',
    answer: 'You can book your cab easily through our website, mobile app, or by contacting our 24x7 customer support team.',
  },
  {
    question: 'What types of vehicles are available for Mumbai to Pune cab bookings?',
    answer: 'We offer a range of vehicles including hatchbacks, sedans, SUVs, and premium cars to suit your travel needs.',
  },
  {
    question: 'Are cabs available for one-way and round trips between Mumbai and Pune?',
    answer: 'Yes, Aaryan Travels offers both one-way and round-trip cab services between Mumbai and Pune.',
  },
  {
    question: 'Are the drivers experienced with the Mumbai-Pune route?',
    answer: 'Absolutely. Our drivers are licensed professionals and well familiar with the Mumbai-Pune highway for a safe journey.',
  },
  {
    question: 'Can I book hourly or full-day packages for Mumbai to Pune travel?',
    answer: 'Yes, we offer flexible hourly and full-day rental packages for your convenience.',
  },
  {
    question: 'What safety and hygiene measures are followed for Mumbai to Pune cab services?',
    answer: 'All vehicles are regularly sanitized, and our drivers follow strict safety protocols to ensure passenger safety.',
  },
  {
    question: 'Is Aaryan Travels cab booking service from Mumbai to Pune available 24x7?',
    answer: 'Yes, our booking and cab services are available 24x7 for Mumbai to Pune travel.',
  },
  {
    question: 'What payment options are accepted for Mumbai to Pune cab bookings?',
    answer: 'We accept cash, credit/debit cards, UPI, and popular digital wallets for smooth payments.',
  },
  {
    question: 'Can I customize pickup and drop-off locations for Mumbai to Pune cab bookings?',
    answer: 'Yes, Aaryan Travels allows you to specify your preferred pickup and drop-off points within Mumbai and Pune.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Rajesh Sharma',
    feedback: 'Aaryan Travels made my Mumbai to Pune trip hassle-free and comfortable. The driver was punctual and courteous.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Neha Desai',
    feedback: 'Booked a cab from Mumbai to Pune with Aaryan Travels. Excellent service and smooth ride throughout the journey.',
    rating: 5,
  },
];
















































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Corporate Cab Services in Pune", link: "corporate-cab-services-in-pune" },
    { place: "/images/keyword/2.jpg", text: "Best Cab Services in Pune", link: "best-cab-services-in-pune" },
    { place: "/images/keyword/3.jpg", text: "Best Cab Services in Kochi", link: "best-cab-services-in-kochi" },
    { place: "/images/keyword/4.jpg", text: "Cab booking from Mumbai to Pune", link: "cab-booking-from-mumbai-to-pune" },
    { place: "/images/keyword/5.jpg", text: "Cab from Pune to Mahabaleshwar", link: "cab-from-pune-to-mahabaleshwar" },
    { place: "/images/keyword/6.jpg", text: "Monthly Cab hire contract in Hyderabad", link: "monthly-cab-hire-contract-in-hyderabad" },
    { place: "/images/keyword/7.jpg", text: "Taxi Services from Pune to Shirdi", link: "taxi-services-from-pune-to-shirdi" },
    { place: "/images/keyword/8.jpg", text: "Pune to Shirdi Cab", link: "pune-to-shirdi-cab" },
    { place: "/images/keyword/9.jpg", text: "Mumbai to Pune Corporate Cab", link: "mumbai-to-pune-corporate-cab" },
    { place: "/images/keyword/10.jpg", text: "Outstation Cab Services from Pune", link: "outstation-cab-services-from-pune" },
    { place: "/images/keyword/11.jpg", text: "Innova Crysta rental in Pune", link: "innova-crysta-rental-in-pune" },
    { place: "/images/keyword/12.jpg", text: "Corporate Cab hire in Pune", link: "corporate-cab-hire-in-pune" },
    { place: "/images/keyword/13.jpg", text: "Pune to Shirdi Corporate Cab booking", link: "pune-to-shirdi-corporate-cab-booking" },
    { place: "/images/keyword/14.jpg", text: "Pune to Mumbai Corporate Cab Services", link: "pune-to-mumbai-corporate-cab-services" },
    { place: "/images/keyword/15.jpg", text: "Monthly Corporate Cab rental in Chennai", link: "monthly-corporate-cab-rental-in-chennai" },
    { place: "/images/keyword/16.jpg", text: "Wedding Corporate Cab bookings in Pune", link: "wedding-cab-bookings-in-pune" },
    { place: "/images/keyword/17.jpg", text: "Corporate Cab Services in Kharadi, Pune", link: "corporate-cab-services-in-kharadi-pune" },
    { place: "/images/keyword/18.jpg", text: "Corporate Cab Services in Ranchi", link: "corporate-cab-services-in-ranchi" },
    { place: "/images/keyword/19.jpg", text: "Corporate Cab Services in Vadodara", link: "corporate-cab-services-in-vadodara" },
    { place: "/images/keyword/20.jpg", text: "Corporate Cab booking in Ranchi", link: "corporate-cab-booking-in-ranchi" },
    { place: "/images/keyword/21.jpg", text: "Corporate Cab booking in Vadodara", link: "corporate-cab-booking-in-vadodara" },
    { place: "/images/keyword/22.jpg", text: "Taxi booking in Ranchi", link: "taxi-booking-in-ranchi" },
    { place: "/images/keyword/23.jpg", text: "Corporate Cab Services in India", link: "corporate-cab-services-in-india" },
    { place: "/images/keyword/24.jpg", text: "Taxi Services in Vadodara, Gujarat", link: "taxi-services-in-vadodara-gujarat" },
    { place: "/images/keyword/25.jpg", text: "Taxi booking in Vadodara", link: "taxi-booking-in-vadodara" }
  ];









const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Cab Booking from Mumbai to Pune",
  "image": "https://aaryantravels.com/assets/images/mumbai-pune-cab.jpg", // replace with actual image URL
  "description": "Convenient and affordable cab booking from Mumbai to Pune with Aaryan Travels. Choose from sedan, SUV, and chauffeur-driven taxis for one-way or round trips. Book online for reliable intercity travel.",
  "brand": {
    "@type": "Brand",
    "name": "Aaryan Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.7",  // example rating, update as needed
    "ratingCount": "5300", // example rating count, update as needed
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "1500",  // example price, adjust as needed
    "availability": "https://schema.org/InStock",
    "url": "https://aaryantravels.com/cab-booking-mumbai-pune"
  }
};





  return (
    <div>

<Helmet>
  <title>Cab Booking from Mumbai to Pune | Affordable & Reliable Taxi | Aaryan Travels</title>
  <meta
    name="description"
    content="Convenient and affordable cab booking from Mumbai to Pune with Aaryan Travels. Choose from sedan, SUV, and chauffeur-driven taxis for one-way or round trips. Book online for reliable intercity travel."
  />
  <meta
    name="keywords"
    content="Cab Booking from Mumbai to Pune, Mumbai to Pune Taxi, Intercity Cab Mumbai Pune, One Way Cab Mumbai to Pune, Outstation Taxi Mumbai Pune, Affordable Mumbai Pune Cab, Mumbai to Pune Chauffeur Cab, Online Cab Booking Mumbai Pune, Mumbai to Pune Sedan Cab, Mumbai to Pune SUV Hire, Best Cab Service Mumbai Pune, Express Cab Mumbai to Pune, Taxi Near Me for Mumbai to Pune, Mumbai Pune Highway Cab, Premium Cab Mumbai to Pune"
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box">
                <h1 className="text-anime-style-3" data-cursor="-opaque">
                   {cardData.keyword}
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>










      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/4.jpg' alt='img' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Aaryan Travels</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Aaryan Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919730707888" className="pc-call">+91 9730707888</a>
                      <a href="tel:+919833377051" className="pc-call">+91 9833377051</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919730707888"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+919730707888" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:bookings@aaryantravels.com" className="pc-email">
                      bookings@aaryantravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Aryan Travels Pune Head Office</strong><br />
                      Flat 304, Plot-82, Prathmesh Krupa, Purnanagar/Chikhali Pune- 411019.
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Cabbookingfrommumbaitopune;